<template>
  <div class="popover">
    <!-- <el-popover placement="bottom" width="200" trigger="click" v-model="visible"> -->
    <el-upload
      class="upload-demo"
      :action="'http://118.190.210.223:10005/upload.php?'+'jparams='+JSON.stringify(jparam)"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :on-success="handleAvatarSuccess"
      multiple
      :limit="5"
      :disabled="$attrs.paramsl.typeCode==1?false:true"
      :on-exceed="handleExceed"
      :file-list="fileList"
    >
      <el-button
        size="small"
        type="primary"
        :disabled="$attrs.paramsl.typeCode==1?false:true"
        @click="abcclick"
      >点击上传</el-button>
      <div slot="tip" class="el-upload__tip">只能上传文件，且不超过500kb，最多只可上传五个文件</div>
    </el-upload>
    <!-- <el-buttom class="reference" @click="visible==true" slot="reference">附件</el-buttom> -->
    <!-- </el-popover> -->
  </div>
</template>

<script>
import tool from "@/utils/tool.js";
// import session from "@/utils/session.js";
let numbername = "";
export default {
  name: "popover",
  data() {
    return {
      visible: false,
      jparam: {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
        type: "other",
        numbers: 0 //tool.getLocal("paramsl_numbers")
      },
      fileList: []
    };
  },
  methods: {
    abcclick() {
      this.jparam.numbers = this.$attrs.paramsl.numbers;
      // console.log(this.jparam);
    },
    // 文件上传成功时的钩子
    handleAvatarSuccess(res, file) {
      if (res.status == 0) {
        file.uid = res.Id;
      }
      if (res.status == 70002) {
        this.$message({
          message: res.description,
          type: "warning"
        });
      }
    },
    // 删除
    handleRemove(file, fileList) {
      let jparams = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        Id:file.uid,
        VchCode: this.$tab.query().VchCode
      };
      this.request
        .post("/index/File/del_bill_files", {
          jparams: JSON.stringify(jparams)
        })
        .then(res => {
          let { status, description } = res;
          if (status == 0) {
            this.$message({
              showClose: true,
              message: description,
              type: "success"
            });
          } else {
            this.$message({
              message: description,
              type: "warning"
            });
          }
        });
    },
    // 点击已上传的钩子
    handlePreview(file) {
      if (file.download_url != undefined) {
        this.$confirm("要下载该文件吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            window.open(file.download_url);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消下载"
            });
          });
      }
    },
    // 新增超过个数
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择  个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    }
  },
  created() {},
  watch: {
    $attrs: {
      handler(newValue, oldValue) {
        this.fileList = this.$attrs.paramsl.fileList;
      }
    }
  }
};
</script>

<style lang="less">
#popover {
  .reference {
    border: none;

    span {
      font-size: 14px !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Common/popover/popover.vue